module.exports = __webpack_public_path__ + "static/media/logo-elite.145174c3.png";